// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var UseLongClick = require("../ui-utils/UseLongClick.bs.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.bs.js");
var Paper = require("@mui/material/Paper").default;
var TextField = require("@mui/material/TextField").default;
var Save = require("@mui/icons-material/Save").default;
var IconButton = require("@mui/material/IconButton").default;
var HelpOutline = require("@mui/icons-material/HelpOutline").default;
var DeleteForever = require("@mui/icons-material/DeleteForever").default;
var CancelOutlined = require("@mui/icons-material/CancelOutlined").default;

function makeInitialState(param) {
  return {
          newText: ""
        };
}

function setNewText(param, text) {
  return {
          newText: text
        };
}

function rndIconButton(icon, onClick, activeOpt, title, colorOpt, param) {
  var active = activeOpt !== undefined ? activeOpt : true;
  var color = colorOpt !== undefined ? Caml_option.valFromOption(colorOpt) : "primary";
  return React.createElement("span", {
              title: title
            }, React.createElement(IconButton, {
                  onClick: (function (param) {
                      Curry._1(onClick, undefined);
                    }),
                  color: color,
                  disabled: !active,
                  children: Caml_option.some(icon)
                }));
}

function MM_cmp_multiline_text(props) {
  var onDelete = props.onDelete;
  var onHelp = props.onHelp;
  var buttonDirHor = props.buttonDirHor;
  var fullWidth = props.fullWidth;
  var width = props.width;
  var renderer = props.renderer;
  var longClickDelayMs = props.longClickDelayMs;
  var longClickEnabled = props.longClickEnabled;
  var editByAltClick = props.editByAltClick;
  var editByClick = props.editByClick;
  var onEditCancel = props.onEditCancel;
  var onEditDone = props.onEditDone;
  var onEditRequested = props.onEditRequested;
  var editMode = props.editMode;
  var text = props.text;
  var editByClick$1 = editByClick !== undefined ? editByClick : true;
  var editByAltClick$1 = editByAltClick !== undefined ? editByAltClick : false;
  var longClickEnabled$1 = longClickEnabled !== undefined ? longClickEnabled : false;
  var longClickDelayMs$1 = longClickDelayMs !== undefined ? longClickDelayMs : 10000;
  var width$1 = width !== undefined ? width : 600;
  var fullWidth$1 = fullWidth !== undefined ? fullWidth : false;
  var buttonDirHor$1 = buttonDirHor !== undefined ? buttonDirHor : true;
  var match = React.useState(function () {
        return {
                newText: ""
              };
      });
  var setState = match[1];
  var state = match[0];
  var tmp;
  if (editByClick$1) {
    if (editByAltClick$1) {
      var partial_arg = MM_react_common.clickClbkMake(undefined, true, undefined, undefined, onEditRequested, undefined);
      var partial_arg$1 = MM_react_common.clickClbkMake(undefined, undefined, undefined, undefined, onEditRequested, undefined);
      tmp = (function (param) {
          return MM_react_common.clickHnd2(partial_arg$1, partial_arg, param);
        });
    } else {
      tmp = (function (param) {
          return MM_react_common.clickHnd(undefined, undefined, undefined, undefined, onEditRequested, undefined, param);
        });
    }
  } else if (editByAltClick$1) {
    var partial_arg$2 = true;
    tmp = (function (param) {
        return MM_react_common.clickHnd(undefined, partial_arg$2, undefined, undefined, onEditRequested, undefined, param);
      });
  } else {
    tmp = (function (param) {
        
      });
  }
  var match$1 = UseLongClick.useLongClick(tmp, longClickEnabled$1 && editByAltClick$1, longClickDelayMs$1, (function (clickAttrs) {
          if (clickAttrs === undefined) {
            return ;
          }
          var alt = clickAttrs.alt;
          if (editByClick$1 && !alt || editByAltClick$1 && alt) {
            return Curry._1(onEditRequested, undefined);
          }
          
        }), onEditRequested);
  var onTouchCancel = match$1.onTouchCancel;
  var onTouchMove = match$1.onTouchMove;
  var onTouchEnd = match$1.onTouchEnd;
  var onTouchStart = match$1.onTouchStart;
  var onMouseOut = match$1.onMouseOut;
  var onMouseLeave = match$1.onMouseLeave;
  var onMouseMove = match$1.onMouseMove;
  var onMouseUp = match$1.onMouseUp;
  var onMouseDown = match$1.onMouseDown;
  var onClick = match$1.onClick;
  React.useEffect((function () {
          if (editMode) {
            Curry._1(setState, (function (__x) {
                    return {
                            newText: text
                          };
                  }));
          }
          
        }), [editMode]);
  var actNewTextUpdated = function (newText) {
    Curry._1(setState, (function (__x) {
            return {
                    newText: newText
                  };
          }));
  };
  var actEditDone = function (param) {
    Curry._1(onEditDone, state.newText.trim());
  };
  var actEditCancel = function (param) {
    Curry._1(onEditCancel, state.newText.trim());
  };
  var rndButtons = function (param) {
    var saveBtn = rndIconButton(React.createElement(Save, {}), actEditDone, true, "Save, Enter", undefined, undefined);
    var cancelBtn = rndIconButton(React.createElement(CancelOutlined, {}), actEditCancel, undefined, "Cancel, Esc", Caml_option.some(undefined), undefined);
    var helpBtn = onHelp !== undefined ? rndIconButton(React.createElement(HelpOutline, {}), onHelp, undefined, "Help", Caml_option.some(undefined), undefined) : null;
    var deleteBtn = onDelete !== undefined ? rndIconButton(React.createElement(DeleteForever, {}), onDelete, undefined, "Clear", Caml_option.some(undefined), undefined) : null;
    if (buttonDirHor$1) {
      return React.createElement(Expln_React_Row.make, {
                  spacing: 0,
                  children: Caml_option.some(null)
                }, saveBtn, cancelBtn, helpBtn, deleteBtn);
    } else {
      return React.createElement(Expln_React_Column.make, {
                  spacing: 0,
                  children: Caml_option.some(null)
                }, saveBtn, cancelBtn, helpBtn, deleteBtn);
    }
  };
  if (editMode) {
    var width$2;
    if (fullWidth$1) {
      var windowWidth = window.innerWidth;
      width$2 = windowWidth - 200 | 0;
    } else {
      width$2 = width$1;
    }
    var partial_arg$3 = MM_react_common.kbrdClbkMake(MM_react_common.keyEsc, undefined, undefined, undefined, actEditCancel, undefined);
    var partial_arg$4 = MM_react_common.kbrdClbkMake(MM_react_common.keyEnter, undefined, undefined, undefined, actEditDone, undefined);
    return React.createElement(Expln_React_Row.make, {
                children: Caml_option.some(null)
              }, React.createElement(TextField, {
                    value: state.newText,
                    size: "small",
                    style: {
                      width: String(width$2) + "px"
                    },
                    multiline: true,
                    minRows: buttonDirHor$1 ? 1 : 6,
                    onChange: (function (param) {
                        return Expln_React_common.evt2str(actNewTextUpdated, param);
                      }),
                    onKeyDown: (function (param) {
                        return MM_react_common.kbrdHnd2(partial_arg$4, partial_arg$3, param);
                      }),
                    autoFocus: true,
                    title: "Enter to save, Shift+Enter to start a new line, Esc to cancel"
                  }), rndButtons(undefined));
  }
  var style = text.trim() === "" ? ({
        padding: "4px"
      }) : ({
        padding: "0px"
      });
  var title = editByAltClick$1 ? (
      longClickEnabled$1 ? "<long-click> (Alt + <left-click>) to change" : "Alt + <left-click> to change"
    ) : "<left-click> to change";
  return React.createElement(Paper, {
              style: style,
              variant: "outlined",
              title: title,
              onClick: onClick,
              onMouseDown: onMouseDown,
              onMouseUp: onMouseUp,
              onMouseMove: onMouseMove,
              onMouseLeave: onMouseLeave,
              onMouseOut: onMouseOut,
              onTouchStart: onTouchStart,
              onTouchEnd: onTouchEnd,
              onTouchMove: onTouchMove,
              onTouchCancel: onTouchCancel,
              children: Caml_option.some(text.trim() === "" || Belt_Option.isNone(renderer) ? React.createElement("pre", undefined, text) : Curry._1(Belt_Option.getExn(renderer), text))
            });
}

var make = MM_cmp_multiline_text;

exports.makeInitialState = makeInitialState;
exports.setNewText = setNewText;
exports.rndIconButton = rndIconButton;
exports.make = make;
/* react Not a pure module */
